<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { PortfolioProjectBuilderViewModel } from '@Projects/Components/PortfolioProjectBuilder'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: PortfolioProjectBuilderViewModel
    }>()

    const emit = defineEmits<{
        (e: 'create-portfolio', name: string | null, description: string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const creating = computed(() => vm.value.creating)

    const name = computed<string | null>({
        get: () => vm.value.name,
        set: val => { vm.value.name = val }
    })

    const description = computed<string | null>({
        get: () => vm.value.description,
        set: val => { vm.value.description = val }
    })

    const nameError = computed(() => vm.value.nameError)
    const descriptionError = computed(() => vm.value.descriptionError)

    // ---------------- methods ----------------

    function handleFormSubmit()
    {
        vm.value.creating = true
        emit('create-portfolio', name.value, description.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create portfolio</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="portfolio-project-builder-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Portfolio name:</label>
                                <input v-model.trim="name" type="text" class="form-control" required minlength="2" maxlength="100">
                                <div v-if="nameError" class="error">{{nameError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Description (optional):</label>
                                <textarea v-model.trim="description" class="form-control"></textarea>
                                <div class="error">{{descriptionError}}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer text-right">
                        <button type="button" @click="close" :disabled="creating" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="portfolio-project-builder-form" :disabled="creating" class="btn btn-primary">
                            {{creating ? 'Creating...' : 'Create'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>